<template>
  <div>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="close">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex sm2>
          <simple-date-picker v-model="filter.date1" label="Desde" :min="date_min" :max="date_max" dark></simple-date-picker>
        </v-flex>
        <v-flex sm2>
          <simple-date-picker v-model="filter.date2" label="Hasta" :min="date_min" :max="date_max" dark></simple-date-picker>
        </v-flex>
      </v-layout>
      <v-btn icon flat @click="getDataFromApi"><v-icon medium>search</v-icon></v-btn>
    </v-toolbar>

    <!-- table -->
    <v-data-table disable-initial-sort expand :headers="headers" :items="items" :loading="loadingItems" class="elevation-1" rows-per-page-text='Mostrar' :rows-per-page-items="[10, 50]">
      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.full_name }}</td>
          <td>{{ props.item.clientDate }}</td>
          <td v-if="props.item.eventCode == 'E'">Entrada</td>
          <td v-if="props.item.eventCode == 'S'">Salida</td>
          <td v-if="props.item.geoLat && props.item.geoLong"><simple-map :ref="props.item.id" :zoom="15" :center="{lng : parseFloat(props.item.geoLong), lat : parseFloat(props.item.geoLat)}"></simple-map></td>
        </tr>
      </template>
    </v-data-table>
    <!-- ./table -->
  </div>
</template>


<script>

import axios from 'axios';
import SimpleMap from '@/components/app/simpleMap.vue';
import SimpleDatePicker from '@/components/app/datePicker';

export default {
  components: {SimpleMap,SimpleDatePicker},
  props: {
    selectedEmployee:null,
    employeeRut: null,
    employeeCompanyRut: null,
    month: null
  },
  data: () => ({
    expand : false,
    filter : {},
    items : [],
    loadingItems:false,
    headers: [
      { text: 'Nombre', value: 'full_name' },
      { text: 'Fecha', value: 'clientDate' },
      { text: 'Tipo', value: 'eventCode' },
    ],
    date_min:null,
    date_max:null
  }),
  mounted () {
    axios.defaults.headers.post['Accept'] = 'application/json';
    axios.defaults.baseURL = localStorage.getItem('ipApiServer');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');


    this.filter.employeeRut = this.selectedEmployee.employeeRut;
    this.filter.employeeCompanyRut = this.selectedEmployee.employeeCompanyRut;
    this.filter.month = this.selectedEmployee.month;

    this.getDataFromApi();
    this.calculateDateLimits();
  },
  methods: {
    getDataFromApi () {
      let $this = this;
      this.loadingItems = true;
      let params = Object.assign(this.filter);
      axios.get( 'admin/getEmployeeRecords', { params : params } )
           .then( function(response){
              $this.items = response.data;
              $this.loadingItems = false;
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
               $this.loadingItems = false;
             }
           });
    },
    close(){
      this.$emit('close',false);
    },
    calculateDateLimits(){
      // let month = this.filter.month+'-10';
      let date_parts = this.filter.month.split('-');
      let fecha = new Date(date_parts[0], date_parts[1] - 1, '01'); //generamos una fecha
      let fd = new Date(fecha.getFullYear(), fecha.getMonth()+1, 0);//obtenemos el ultimo dia del mes

      //formamos los strign de fechas del ultimo y primer dia del mes
      this.date_max = fd.getFullYear() + '-' + (fd.getMonth()+1) + '-' + fd.getDate();
      this.date_min = fd.getFullYear() + '-' + (fd.getMonth()+1) + '-01';
    }
  }

};

</script>
